import axios from 'axios';

export default {
    state: {
        events: [],
        event_types: []
    },
    getters: {
        events(state) {
            return state.events;
        },
        event_types(state) {
            return state.event_types;
        }
    },
    mutations: {
        setEvents(state, events) {
            state.events = events;
        },
        setEventTypes(state, event_types) {
            state.event_types = event_types;
        }
    },
    actions: {
        async getEventTypes({ commit }) {
            let res = await axios.get(`/event_types`);
            let event_types = res.data;
            commit('setEventTypes', event_types)
        },
        async getEvents({ commit }, eventTypeId) {
            let res = await axios.get(`/events`);
            let events = res.data.data;
            commit('setEvents', events)
        }
    }
};